import React from "react";
import CommonSwal from "../../../../components/Swal/commonSwal";
import CommonInputMask from "../../../../components/forms/CommonInputMask";
import {
  handleChange,
  handleChangeNumeral,
  handleChangeUnmask,
} from "../../../../helpers/handleFormChanges";
import CommonInput from "../../../../components/forms/CommonInput";
import PropTypes from "prop-types";

function ClienteEndereco({ valuesHook, cepApi, sent }) {
  const { clienteValues, setClienteValues } = valuesHook;
  const { getCep, cepResponse } = cepApi;

  //Busca dados do CEP
  React.useEffect(() => {
    if (!clienteValues?.cep || clienteValues?.cep.length !== 8) return;
    try {
      getCep(clienteValues.cep);
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  }, [getCep, clienteValues.cep]);

  //Define o retorno da api nos valores dos campos
  React.useEffect(() => {
    if (!cepResponse) return;
    setClienteValues((clienteValues) => ({
      ...clienteValues,
      logradouro: cepResponse.logradouro,
      bairro: cepResponse.bairro,
      cidade: cepResponse.localidade,
      uf: cepResponse.uf,
      codigo_cidade: cepResponse.ibge,
    }));
  }, [cepResponse, setClienteValues]);

  return (
    <>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonInputMask
            mask="99999-999"
            label="CEP"
            id="cep"
            value={clienteValues.cep}
            onChange={(e) =>
              handleChangeUnmask(e, clienteValues, setClienteValues)
            }
            required
            sent={sent}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="Logradouro"
            id="logradouro"
            value={clienteValues.logradouro}
            onChange={(e) => handleChange(e, clienteValues, setClienteValues)}
            required
            limit={40}
            sent={sent}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="N°"
            id="numero"
            value={clienteValues.numero}
            onChange={(e) =>
              handleChangeNumeral(e, clienteValues, setClienteValues)
            }
            required
            sent={sent}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Complemento"
            id="complemento"
            value={clienteValues.complemento}
            onChange={(e) => handleChange(e, clienteValues, setClienteValues)}
            limit={30}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Bairro"
            id="bairro"
            value={clienteValues.bairro}
            onChange={(e) => handleChange(e, clienteValues, setClienteValues)}
            required
            limit={30}
            sent={sent}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Cidade"
            id="cidade"
            value={clienteValues.cidade}
            onChange={(e) => handleChange(e, clienteValues, setClienteValues)}
            required
            disabled
            sent={sent}
          />
        </div>
        <div className="row">
          <div className="col-lg-2 mb-3">
            <CommonInput
              label="UF"
              id="uf"
              value={clienteValues.uf}
              onChange={(e) => handleChange(e, clienteValues, setClienteValues)}
              required
              disabled
              sent={sent}
            />
          </div>
          <div className="col-lg-3 mb-3">
            <CommonInput
              label="Código da cidade"
              id="codigo_cidade"
              value={clienteValues.codigo_cidade}
              onChange={(e) => handleChange(e, clienteValues, setClienteValues)}
              required
              disabled
              sent={sent}
            />
          </div>
        </div>
      </div>
    </>
  );
}

ClienteEndereco.propTypes = {
  valuesHook: PropTypes.shape({
    clienteValues: PropTypes.object.isRequired,
    setClienteValues: PropTypes.func.isRequired,
  }).isRequired,
  cepApi: PropTypes.shape({
    getCep: PropTypes.func.isRequired,
    cepResponse: PropTypes.object,
  }).isRequired,
  sent: PropTypes.bool.isRequired,
};

export default ClienteEndereco;
